import officialRules from "../../shared/src/officialRules.json";
import { campaignConfig } from "./config";

export function RulesPage() {
  return (
    <main className="content-page rules-page">
      <article className="content-wrap">
        <span className="eyebrow">Smithfield Little League</span>
        <h1>Light the Future 50/50 Raffle Official Rules</h1>
        <p className="lede">Effective September 8, 2026</p>
        <p><a className="button button-primary" href={campaignConfig.officialRulesPdf}>Download official rules (PDF)</a></p>
        <p>{campaignConfig.licenseDisplay}</p>
        {officialRules.map((section) => (
          <section key={section.title}>
            <h2>{section.title}</h2>
            {section.paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
          </section>
        ))}
        <p><a href={`mailto:${campaignConfig.contactEmail}`}>Contact SLL about these rules</a></p>
      </article>
    </main>
  );
}
